import React from "react";
import ReactDOM from "react-dom/client";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import "@/lib/axiosDefaults";
import { initTheme } from "@/lib/theme";
import "@/index.css";
import AppWrapper from "@/App";
import {
  FeatureFlagBridgeStatic,
  FeatureFlagBridgeWithLd,
} from "@/contexts/FeatureFlagContext";

initTheme();

const clientSideID = (
  (typeof window !== "undefined" && window.__ENV__?.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID) ||
  process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID ||
  ""
).trim();

const ldContext = {
  kind: "user",
  key: "anonymous",
  anonymous: true,
};

async function bootstrap() {
  const rootEl = document.getElementById("root");
  if (!rootEl) {
    throw new Error("LaunchDarkly bootstrap: #root element not found");
  }

  const root = ReactDOM.createRoot(rootEl);

  if (!clientSideID) {
    console.warn(
      "[LaunchDarkly] REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID is not set; hide flags default off (all menu items visible).",
    );
    root.render(
      <React.StrictMode>
        <FeatureFlagBridgeStatic>
          <AppWrapper />
        </FeatureFlagBridgeStatic>
      </React.StrictMode>,
    );
    return;
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID,
    context: ldContext,
    timeout: 5,
  });

  root.render(
    <React.StrictMode>
      <LDProvider>
        <FeatureFlagBridgeWithLd>
          <AppWrapper />
        </FeatureFlagBridgeWithLd>
      </LDProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
